// This Filter is used for filtering items. we need to pass the keys we are searching
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
@Pipe({
    name: 'filter'
})

export class FilterPipe implements PipeTransform {
    transform(items: any[], searchText: string, searchKey: any[]): any[] {
        if (!items) return [];
        if (!searchText) return items;
        searchText = searchText.toString().toLowerCase();
        return items.filter(it => {
            let tempArrStr = _.valuesIn(_.pick(it, searchKey)).join();
            return tempArrStr.toLowerCase().includes(searchText);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filter.pipe.ts